//@flow
import React, { useState } from 'react';
import { MenuItems } from 'components/molecules/menuItems';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  restaurantCategories: Array<RestaurantCategory>,
};

const DiningMenu = (props: Props) => {
  const { restaurantCategories } = props.data;
  const { height } = useViewport();

  const selectedOutletData = restaurantCategories[0]
    ? restaurantCategories[0]
    : [];

  const [imageToShow, setImageToShow] = useState({
    originalImage:
      selectedOutletData.length > 0 ? selectedOutletData[0].listImageUrl : '',
    thumbnailImage:
      selectedOutletData.length > 0
        ? selectedOutletData[0].thumbnailListImageUrl
        : '',
    imageId: selectedOutletData.length > 0 ? selectedOutletData[0].id : '',
  });
  const renderImageToDisplay = () => {
    return (
      <div className={'menu-category-container'}>
        <div className={'menu-image-container'}>
          {selectedOutletData[0] && imageToShow && (
            <img // Not using IMAGE ATOM because the animation of IMAGE ATOM is results in late loading of images
              src={imageToShow.originalImage}
              alt={'category'}
              key={imageToShow.imageId}
            />
          )}
        </div>
      </div>
    );
  };
  const imageToDisplay = image => {
    setImageToShow(image);
  };
  return (
    <div className={'dining-menu-container'} style={{ height }}>
      <MenuItems
        outletFoodCategory={
          selectedOutletData.length > 0 ? selectedOutletData : []
        }
        imageToDisplayOnClick={imageToDisplay}
        selectedFoodCategoryValue={restaurantCategories}
      />
      {renderImageToDisplay()}
    </div>
  );
};

export default DiningMenu;
